import Vue from 'vue'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import axios from 'axios'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue'

const csrfMeta = document.head.querySelector('meta[name="csrf-token"]')
if (csrfMeta && csrfMeta.content) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfMeta.content
  axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
}

Vue.config.productionTip = false
Vue.mixin({ methods: { route: window.route } })
Vue.use(PortalVue)
Vue.use(VueMeta)

// translation file values
Vue.mixin(require('./base'))

InertiaProgress.init()

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  setup({ el, app, props }) {
    new Vue({
      metaInfo: {
        titleTemplate: title => (title ? `${title} - O-NOW` : 'O-NOW'),
      },
      render: h => h(app, props),
    }).$mount(el)
  },
})
